export default {
    computed: {
        formIsValid: {
            set(value) {
                this.$store.commit('calculators/setFormIsValid', value);
            },
            get() {
                return this.$store.getters['calculators/getFormIsValid'];
            }
        },
        checking: {
            set(value) {
                this.$store.commit('calculators/setChecking', value);
            },
            get() {
                return this.$store.getters['calculators/getChecking'];
            }
        },
        current_step: {
            set(value) {
                this.$store.commit('calculators/setCurrentStep', value);
            },
            get() {
                return this.$store.getters['calculators/getCurrentStep'];
            }
        },
        current_tab: {
            set(value) {
                this.$store.commit('calculators/setCurrentTab', value);
            },
            get() {
                return this.$store.getters['calculators/getCurrentTab'];
            }
        },
        editable_steps: {
            set(value) {
                this.$store.commit('calculators/setEditableSteps', value);
            },
            get() {
                return this.$store.getters['calculators/getEditableSteps'];
            }
        },
        client_rating: {
            set(value) {
                this.$store.commit('calculators/setClientRating', value);
            },
            get() {
                return this.$store.getters['calculators/getClientRating'];
            }
        },
        client_search_results() {
            return this.$store.getters['calculators/getClientSearchResults'];
        },

        education_options() {
            return this.$store.getters['calculators/getEducationOptions'];
        },
        gender_options() {
            return this.$store.getters['calculators/getGenderOptions'];
        },
        smoking_options() {
            return this.$store.getters['calculators/getSmokingOptions'];
        },

        unlimited() {
            return this.$store.getters['mycover/getUnlimited']
        },
    },

    methods: {
        currencyFilter(object) {
            if (typeof object.suffix == 'undefined' || (typeof object.suffix !== 'undefined'  && object.suffix !== 'pm')) {
                return this.$options.filters.currency_no_decimals(object.value);
            }

            return this.$options.filters.currency(object.value);
        }
    }
};
